import { Mapper } from '../../../../common/ddd/mapper.base';
import { formatDeviationPrefix } from '../../../../common/utils/format-deviation.util';
import { formatDuration } from '../../../../common/utils/format-duration.util';
import { AccountAverageWorkingHoursSummaryAggregateRoot } from '../../../../core/domain/aggregates/org-metrics/working-hours/account-average-working-hours-summary.aggregate-root';
import { GetAccountAverageWorkingHoursSummaryResponseDto } from '../../../../interface/dtos/org-metrics/working-hours/get-account-average-working-hours-summary.response.dto';

export type IAccountAverageWorkingHoursSummaryAggregateRootMapper = Mapper<
  AccountAverageWorkingHoursSummaryAggregateRoot,
  GetAccountAverageWorkingHoursSummaryResponseDto
>;

export class AccountAverageWorkingHoursSummaryAggregateRootMapper
  implements
    Omit<IAccountAverageWorkingHoursSummaryAggregateRootMapper, 'toDomain'>
{
  toResponse(
    entity: AccountAverageWorkingHoursSummaryAggregateRoot
  ): GetAccountAverageWorkingHoursSummaryResponseDto {
    return AccountAverageWorkingHoursSummaryAggregateRootMapper.toResponse(
      entity
    );
  }

  static toResponse(
    entity: AccountAverageWorkingHoursSummaryAggregateRoot
  ): GetAccountAverageWorkingHoursSummaryResponseDto {
    return {
      averageWorkingHours: formatDuration(entity.averageWorkingHours),
      averageDeviation: `${formatDeviationPrefix(
        entity.averageDeviation
      )}${formatDuration(entity.averageDeviation)}`,
    };
  }
}
